import MenuItem from "./../../../core/components/menu/MenuItem";
import i18n from '../../../shared/i18n'
import DependedField from "./DependedField.vue";

let routes = [{
  path: 'dependent-fields',
  name: 'dependent-fields',
  component: DependedField,
  meta: {
    requiresAuth: true
  }
}];

export default {
  menuItem: new MenuItem('/dependent-fields', i18n.t('Dependent Fields'), 40, 'list-alt'),
  routes: routes
}
